import Vue from 'vue'

const actions = {
  loadCountries ({ commit }) {
    return new Promise((resolve, reject) => {
      Vue.axios.get('/countries.json').then((response) => {
        commit('SET_COUNTRIES', { countries: response.data })

        resolve(response)
      }, error => {
        reject(error)
      })
    })
  }
}

export default actions
